import axios from "axios"
import { getPermissionByRole } from "./PermissionAction"

export const login = (data) => async (dispatch) => {
    try {
        dispatch({ type: "LOGIN_PENDING" })
        const response = await axios.post("/api/admin/v1/admin/login", data)
        localStorage.setItem("tourism_admin", JSON.stringify(response.data))
        dispatch({ type: "LOGIN_FULFILLED", payload: response.data })
        
        // Fetch permissions immediately after login
        if (response.data?.roleId && response.data?.token) {
            dispatch(getPermissionByRole(response.data.roleId, response.data.token, true))
        }

    } catch (error) {
        dispatch({ type: "LOGIN_FAILED", payload: error.response })
    }
}

export const logout = () => async (dispatch) => {
    localStorage.removeItem("tourism_admin")
    dispatch({ type: "LOG_OUT_FULFILLED" })
}

